function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.2696 68.1951C54.2696 65.8751 52.3896 63.9951 50.0696 63.9951C47.7496 63.9951 45.8696 65.8751 45.8696 68.1951C45.8696 70.5151 47.7496 72.3951 50.0696 72.3951C52.3896 72.3951 54.2696 70.5151 54.2696 68.1951Z",
  fill: "#DD0060"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0007 38.8294C78.2537 26.4064 64.6697 18.8734 50.0687 18.9054C35.4687 18.8734 21.8847 26.4064 14.1377 38.8294",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M73.9045 50.4499C68.9115 42.6439 60.3175 37.9109 51.0765 37.8789C41.8355 37.9109 33.2405 42.6439 28.2485 50.4499",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M98.0693 28.0122C81.2653 1.4022 46.1523 -6.4958 19.6433 10.3712C12.5603 14.8782 6.55934 20.9022 2.06934 28.0122",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.0692 58.5947C44.7672 58.5947 40.4692 62.8927 40.4692 68.1947C40.4692 73.4967 44.7672 77.7947 50.0692 77.7947C55.3712 77.7947 59.6692 73.4967 59.6692 68.1947C59.6692 62.8927 55.3712 58.5947 50.0692 58.5947Z",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "square"
});

function SvgWifi2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 80,
    viewBox: "0 0 101 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi2);
export default __webpack_public_path__ + "static/media/wifi2.5b9f48d5.svg";
export { ForwardRef as ReactComponent };